"use client";
import Image from "next/image";
import bgHeroImage from "@/assets/images/hero-bg-home.svg";
import TickerBanner from "@/components/shared/navbar/TickerBanner";
import { BookDemoHubspotButtonUrl } from "@/utils/hubspot-contants";
import leftFeaturesImage from "@/assets/images/home-top-left-features.svg";
import rightFeaturesImage from "@/assets/images/home-top-right-features.svg";
import { Zap, Shield, Lock } from "lucide-react";
import CustomButton from "@/components/common/CustomButton";
import CommonSubtitle from "@/components/common/CommonSubtitle";

const HomeTopArea = () => {
  return (
    <>
      <section className="relative z-10 overflow-hidden">
        <div className="pt-[72px]">
          <div
            className="bg-white xl:pb-[100px] xl:pt-[76px]"
            style={{
              background: `url(${bgHeroImage.src})`,
              backgroundColor: "#ffffff",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <TickerBanner
              message="Kroolo launches"
              actionText="Enterprise Search! 🎉"
              actionUrl="/blog/kroolo-enterprise-search-the-ai-search-engine-built-formodern-enterprises"
            />
            <div
              id="hero-section"
              className="container relative mx-auto px-4 text-[#fff] xl:px-6"
            >
              <div className="absolute left-0 top-0 hidden xl:block">
                <Image
                  src={leftFeaturesImage}
                  alt="Kroolo home - Left features overview"
                  priority
                  draggable={false}
                  height={500}
                  width={300}
                />
              </div>
              <div className="flex h-full flex-col items-center gap-4 py-16 xl:mx-auto xl:min-h-[600px] xl:justify-center xl:gap-12 xl:py-0 2xl:min-h-[600px]">
                <div className="flex w-full flex-col gap-4 text-center xl:max-w-[640px] xl:gap-6">
                  <div className="mx-auto inline-flex w-fit rounded-full bg-white px-3 py-1 text-sm font-semibold">
                    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                      #futureofwork
                    </span>
                  </div>
                  <h1 className="text-[36px] font-bold text-[#202020] lg:text-[64px]">
                    Your AI WorkOS <br />
                    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                      Infinite Possibilities
                    </span>
                  </h1>
                  <CommonSubtitle
                    color="#202020"
                    fontSizeWeight="max-w-[540px] mx-auto text-center"
                  >
                    Kroolo unifies Work, AI Agents, and Search into a single
                    intelligence layer. Replace 10+ fragmented apps with one
                    AI-native platform.
                  </CommonSubtitle>
                  <div className="mx-auto flex items-center gap-2 xl:gap-4">
                    <CustomButton
                      text="Book a Demo"
                      url={BookDemoHubspotButtonUrl}
                      variant="primary"
                      version="black"
                    />
                    <CustomButton
                      text="Watch Video"
                      videoUrl="https://www.youtube.com/embed/yTM3v5m4upk?autoplay=1"
                      variant="secondary"
                      version="black"
                      watchIcon
                    />
                  </div>
                  <div className="mx-auto mt-2 flex flex-wrap items-center justify-center gap-6 xl:gap-8">
                    <div className="flex items-center gap-2">
                      <Zap className="h-5 w-5 text-[#202020]" />
                      <span className="text-[14px] text-[#202020] xl:text-[16px]">
                        Fast Setup
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Shield className="h-5 w-5 text-[#202020]" />
                      <span className="text-[14px] text-[#202020] xl:text-[16px]">
                        Enterprise Controls
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Lock className="h-5 w-5 text-[#202020]" />
                      <span className="text-[14px] text-[#202020] xl:text-[16px]">
                        Secure by Design
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute right-0 top-0 hidden xl:block">
                <Image
                  src={rightFeaturesImage}
                  alt="Kroolo home - Right features overview"
                  priority
                  draggable={false}
                  height={500}
                  width={300}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTopArea;
